import * as types from "./actionTypes"

const initialState = {
    emails: [],
    emailSavedSuccessfully: false,
}

export default function emailNotificationsReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case types.EMAIL_NOTIFICATION_SUCCESS:
            return {
                ...state,
                emails: action.payload.configData,
                configId: action.payload.configId,
            }
        case types.CREATE_NEW_EMAILS_SUCCESS:
            return {
                ...state,
                emailSavedSuccessfully: true,
            }
        case types.UPDATE_EMAILS_SUCCESS:
            return {
                ...state,
                emailSavedSuccessfully: true,
            }
        case types.EMAIL_NOTIFICATION_RESET_SAVE:
            return {
                ...state,
                emailSavedSuccessfully: false,
            }
        default:
            return state
    }
}
